export default{
    baseDetails: {
        Alert: {
            error: {
                title: 'Notification', // 错误提示标题
                text: 'Data request failed. Please try again.', // 错误信息
                buttonText: 'OK' // 确认按钮
            }
        },
        Description: {
            title: 'Premium Farm Base', // 优选基地
            module1: {
                text1: 'Area: ', // 基地面积
                text2: ' acres', // 亩（保留中文单位）
                text3: 'Crops: ', // 种植作物
                text4: 'Annual Yield: ', // 年产量
                text5: ' kilograms', // 公斤
                text6: 'Annual Output Value', // 年产值
                text7: ' million CNY', // 万元
                text8: 'Contact: ', // 联系人
                text9: 'Phone: ', // 联系方式
                text10: 'Address: ', // 联系地址
                button: '720° Virtual Tour' // 基地720云游
            },
            module2: {
                title: 'Base Products' // 基地产品
            },
            module3: {
                title: 'Base Introduction' // 基地介绍
            },
            module4: {
                title: 'Base Videos' // 基地视频
            },
            module5: {
                title: 'Environmental Monitoring' // 环境监测
            }
        },
        Dialog: {
            title: 'Virtual Farm Tour' // 基地云游弹窗标题
        }
    }  
}